import componentComposition from 'lib/trait/composition/component'

const descriptor = 'Gaia.Form'

export default componentComposition(descriptor)
